module.exports = __webpack_public_path__ + "static/media/coin-3.8b6a1244.gif";